import React from 'react';

import { CampaignHealthStatusPortal } from './CampaignHealthStatusPortal';

export interface CampaignsHealthStatusRendererProps {
  campaignIds: number[];
  portalContainerIdPrefix?: string;
}

export function CampaignsHealthStatusRenderer({
  campaignIds,
  portalContainerIdPrefix = 'ops',
}: CampaignsHealthStatusRendererProps) {
  return (
    <>
      {campaignIds.map((campaignId) => (
        <CampaignHealthStatusPortal
          key={campaignId}
          campaignId={campaignId}
          portalContainerIdPrefix={portalContainerIdPrefix}
        />
      ))}
    </>
  );
}
